import { failureAction, successAction, startAction } from '../../common'
import {
  DELETE_TOURNAMENT,
  RESET_DELETE_TOURNAMENT,
} from '../types'

export const initialState = {
  deleting: false,
  deleted: false,
  error: {},
}

const reducer = ({ delete: state }, action) => {
  switch (action.type) {
    case startAction(DELETE_TOURNAMENT):
      return {
        ...state,
        deleting: true,
        deleted: false,
        error: {},
      }
    case successAction(DELETE_TOURNAMENT):
      return {
        ...state,
        deleting: false,
        deleted: true,
        error: {},
      }
    case failureAction(DELETE_TOURNAMENT):
      return {
        ...state,
        deleting: false,
        deleted: false,
        error: action.payload,
      }

    case RESET_DELETE_TOURNAMENT:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default reducer
